import { render } from "./UlooperUpdaterDownload.vue?vue&type=template&id=606b0a0f&scoped=true"
import script from "./UlooperUpdaterDownload.vue?vue&type=script&lang=js"
export * from "./UlooperUpdaterDownload.vue?vue&type=script&lang=js"

import "./UlooperUpdaterDownload.vue?vue&type=style&index=0&id=606b0a0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606b0a0f"]])

export default __exports__